import { BasePunishActionModel, PunishActionTypesEnum } from "../..";

export class DisabledAction extends BasePunishActionModel {
  type = PunishActionTypesEnum.Disabled
}
